//FOR HYPERLINK, 
import React from 'react'
import { IconEye } from './Icons'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core'
import Grid from '@material-ui/core/Grid/Grid'
import Typography from '@material-ui/core/Typography/Typography'

const styles = {}
const ButtonLink = ({ label }) => (
    <Grid container direction="row">
        <Grid item>
            <IconEye />
        </Grid>
        <Grid item>
            <Typography variant="caption" color="textSecondary">
                {label}
            </Typography>
        </Grid>
    </Grid>
)

export default withRouter(withStyles(styles)(ButtonLink))
